<div fxLayout="column" fxFlexFill class="content-container" fxLayoutGap="5px">
  <app-grid-filter
    placeholder="Type '/' to bring up a list of available filters, or type any text to search"
    [filterOptions]="filterOptions"
    (filterChangeEvent)="onFilterChanged($event)"
  >
    <app-filter-row-additional-content>
      <div *ngIf="hasEditAccess" fxLayout="row" fxLayoutAlign="space-around center" fxLayoutGap="5px">
        <button
          mat-raised-button
          color="primary"
          matTooltip="Clone Role"
          [disabled]="!accRoles.length"
          (click)="onCloneRole()"
        >
          Clone Role
        </button>
        <button mat-raised-button color="primary" matTooltip="Create a new role" (click)="onCreateNewRole()">
          + Add
        </button>
      </div>
    </app-filter-row-additional-content>
  </app-grid-filter>
  <div fxFlex class="stretched-container">
    <app-roles-grid [filterChangeEvent]="filterChangeEvent" [dataSource]="dataSource"></app-roles-grid>
  </div>
</div>
